(function () {
  const replacements = [
    {
      from: 'Subscribe to get LUCKY DISCOUNT',
      to: 'Unlock Your Exclusive Discount',
    },
    {
      from: 'GET DISCOUNT',
      to: 'CLAIM MY DISCOUNT',
    },
  ];
  const placeholderReplacements = {
    'Just leave your email': 'Enter your email',
  };

  function normalizeText(value) {
    return value.replace(/\s+/g, ' ').trim();
  }

  function replaceTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      const text = normalizeText(node.nodeValue || '');
      const replacement = replacements.find((item) => item.from === text);

      if (replacement) {
        node.nodeValue = replacement.to;
      }

      node = walker.nextNode();
    }
  }

  function replaceElementCopy(root) {
    if (!root.querySelectorAll) return;

    root.querySelectorAll('h1, h2, h3, h4, p, span, div, button, a, label').forEach((element) => {
      if (element.children.length > 3) return;

      const text = normalizeText(element.textContent || '');
      const replacement = replacements.find((item) => item.from === text);

      if (replacement) {
        element.textContent = replacement.to;
      }
    });
  }

  function replaceFormCopy(root) {
    root.querySelectorAll('input, textarea').forEach((field) => {
      const placeholder = field.getAttribute('placeholder');
      if (placeholder && placeholderReplacements[placeholder]) {
        field.setAttribute('placeholder', placeholderReplacements[placeholder]);
      }
    });

    root.querySelectorAll('input[type="submit"], button').forEach((button) => {
      const value = button.getAttribute('value');
      if (value) {
        const replacement = replacements.find((item) => item.from === normalizeText(value));
        if (replacement) {
          button.setAttribute('value', replacement.to);
        }
      }
    });
  }

  function updatePopupCopy(root) {
    replaceElementCopy(root);
    replaceTextNodes(root);
    replaceFormCopy(root);
  }

  updatePopupCopy(document.body);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        updatePopupCopy(node);
      });

      if (mutation.type === 'characterData' && mutation.target.parentElement) {
        updatePopupCopy(mutation.target.parentElement);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true,
  });
})();
